import 'extensions/ui-components/g-modal';
import 'extensions/ui-components/x-message';
import {PageManager} from 'genesis-packages/core';
import './LOGN.scss';

/**
 * @typedef SSOMessageDataError
 * @prop {number} count
 * @prop {string[]} messages
 */

/**
 * @typedef SSOMessageData
 * @prop {'SSO'} type
 * @prop {boolean} success
 * @prop {string} redirect
 * @prop {SSOMessageDataErrors} error
 */

export default class LOGN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		// Add event listener to listen to posted messages from the iframe
		this.handleMessage = this._handleMessage.bind(this);
		window.addEventListener('message', this.handleMessage, false);
	}

	/**
	 * Event handler for iframe messages via window.postMessage. Used for SSO login redirects.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
	 * @param {MessageEvent<SSOMessageData>} e
	 */
	_handleMessage (e) {
		// Only allow redirect messages from self
		if (e.origin === window.location.origin && e.data.type === 'SSO') {
			if (e.data.success) {
				window.location = e.data.redirect;
			}
			else {
				// Close modal
				const modal = document.getElementById('js-login-modal');
				modal.close();

				// Clear messages container
				const messagesContainer = document.getElementById('messages');
				messagesContainer.innerHTML = '';

				// Inject error messages into "messages" div
				for (let message of e.data.error.messages) {
					const xMessage = document.createElement('x-message');
					xMessage.type = 'error';
					xMessage.innerHTML = message;

					messagesContainer.appendChild(xMessage);
				}
			}
		}
	}

};
